import { Edit, SimpleForm, TextInput, SelectInput } from 'react-admin';
import { Box, Typography } from '@mui/material';

export const QualificationEdit = () => (
  <Edit>
    <SimpleForm>
      <Typography variant="h6" sx={{ mb: 1 }}>Qualification Details</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1 }}>
        <TextInput source="name" fullWidth />
        <TextInput source="type" fullWidth />
        <TextInput source="institution" fullWidth />
        <TextInput source="level" fullWidth />
        <TextInput source="tutorId" label="Tutor ID" fullWidth />
        <TextInput source="issuedDate" type="date" fullWidth />
        <TextInput source="expiryDate" type="date" fullWidth />
        <TextInput source="verificationReference" label="Verification Reference" fullWidth />
        <SelectInput
          source="status"
          choices={['Active', 'Expired', 'Pending'].map(s => ({ id: s, name: s }))}
          fullWidth
        />
      </Box>
      <TextInput source="description" multiline rows={3} fullWidth sx={{ mt: 1 }} />
    </SimpleForm>
  </Edit>
);
